export function readFileAsImageString(file: File): Promise<string> {
  const reader = new FileReader();
  const promise = new Promise<string>((resolve, reject) => {
    reader.onload = ev => resolve(ev.target?.result as string);
    reader.onerror = ev => reject(ev.target?.error);
    reader.onabort = () => reject(Error('aborted by user'));
  });
  reader.readAsDataURL(file);
  return promise;
}

export function toHtmlImageElement(base64EncodedImage: string) {
  const image = new Image();
  const promise = new Promise<HTMLImageElement>((resolve, reject) => {
    image.onload = () => resolve(image);
    image.onerror = ev => reject(ev);
    image.onabort = () => reject(Error('aborted by user'));
  });
  image.src = base64EncodedImage;
  return promise;
}
